import Tasks from 'APP/Tasks';
import Entities from 'STORE';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import { getLinkPreview } from './getLinkPreview';

export async function editScheduledTextMessage(
  groupId: string,
  message: ChatMessage
): Promise<boolean> {
  const inputPanel = Entities.InputPanelsStore.getById(groupId);
  if (!inputPanel) {
    return false;
  }

  if (inputPanel.isEmptyValue) {
    return false;
  }

  const newText = inputPanel.markdownValue.trim();
  const oldPayload = message.payload.toJSON();

  if (message.payload.text.trim() === newText) {
    Tasks.messaging.clearInputPanel(groupId);
    return false;
  }

  message.payload.text = newText;
  message.payload.linkPreview = getLinkPreview(groupId);
  message.payload.linkPreviewCancelled = inputPanel.linkPreviewCancelled;
  message.payload.userMentions = Tasks.messaging.getMentionsDataFromText(newText);

  const canEdit = Tasks.messaging.canSendMessage({
    groupId,
    isCheckSlowMode: false,
    isNewMessage: false,
    payload: message.payload,
  });

  if (!canEdit.result) {
    message.payload.text = oldPayload.text;
    message.payload.linkPreview = oldPayload.linkPreview;
    message.payload.linkPreviewCancelled = oldPayload.linkPreviewCancelled;
    message.payload.userMentions = oldPayload.userMentions;

    canEdit.error && Tasks.app.showToast(canEdit.error);
    return false;
  }

  await Tasks.messaging.editScheduledMessage({
    message,
    date: new Date(message.serverTime),
  });

  return true;
}
